import type { Operator, OperatorAccesses } from "~domain/operators/models/operator-model.ts";

import { defineStore } from "pinia";
import { type ComputedRef, computed, type Ref, ref } from "vue";
import { justify } from "~utils/string.ts";

export const OPERATOR_STORE_KEY = "OPERATOR_STORE";

export type UseOperatorStoreResults = {
  accesses: Ref<OperatorAccesses | undefined>;
  operator: Ref<Operator | undefined>;
  isLoggedIn: ComputedRef<boolean>;
  operatorFullName: ComputedRef<string | undefined>;
  saveOperator(data: { operator: Operator; accesses: OperatorAccesses }): void;
};

export const useOperatorStore = defineStore<typeof OPERATOR_STORE_KEY, UseOperatorStoreResults>(
  OPERATOR_STORE_KEY,
  () => {
    const accesses = ref<OperatorAccesses | undefined>(undefined);
    const operator = ref<Operator | undefined>(undefined);

    function saveOperator(data: { operator: Operator; accesses: OperatorAccesses }) {
      accesses.value = data.accesses;
      operator.value = data.operator;
    }

    const isLoggedIn = computed(() => {
      return operator.value !== undefined;
    });

    const operatorFullName = computed(() => {
      if (!operator.value) {
        return undefined;
      }

      return `${justify(operator.value.firstname)} ${operator.value.lastname?.toUpperCase()}`;
    });

    return {
      accesses,
      operator,
      isLoggedIn,
      operatorFullName,
      saveOperator,
    } satisfies UseOperatorStoreResults;
  },
  {
    persist: false,
  },
);
